import { Group, Paper, Title } from '@mantine/core';

interface Props {
  name?: string;
  controls?: JSX.Element[];
}

export const PageHeader = (props: Props): JSX.Element => {
  return (
    <Paper withBorder radius="md" className="justify-center p-4">
      <Group justify="space-between">
        <Title order={2}>{props.name}</Title>
        <Group gap={1}>
          {props.controls?.map((control, index) => (
            <div key={index}>{control}</div>
          ))}
        </Group>
      </Group>
    </Paper>
  );
};
